import {MDCSnackbar} from '@material/snackbar';
import {MDCDialog} from '@material/dialog';
const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
const cart_badge = document.querySelector('.cart-badge');

function assignCartButtons() {
  const buttons = document.querySelectorAll('button');
  buttons.forEach(b => {
    b.addEventListener('click', function() {
      const pid = b.dataset.pid
      const ctl = b.dataset.ctl
      if (ctl === "ConfirmDeleteCartItem") {
        confirmDeleteCartItem({ pid: pid })
      }
      if (ctl === "PlusCartItem") {
        plusCartItem({ pid: pid })
      }
      if (ctl === "MinusCartItem") {
        minusCartItem({ pid: pid })
      }
    })
  })
}
assignCartButtons();

export const confirmDeleteCartItem = (params) => {
  const dialog = new MDCDialog(document.querySelector('.cart-delete-item-dialog'));
  fetch('cart-confirm-delete/' + params.pid, {
      method: 'GET',
      credentials: 'include'
    })
    .then(result => {
      const p = Promise.resolve(result.json());
      p.then(v => {
        document.querySelector('#dialogConfirmDeleteContainer').innerHTML = v.html;
        dialog.open();
      });
    })
    .catch(err => {
      console.log(err)
    });
}

export const minusCartItem = (params) => {
  const cart_dropdown = document.querySelector('.cart-dropdown__item__info__total');
  const cart_item_qty = document.querySelector('#cartitemqty_' + params.pid);
  const cart_item_total = document.querySelector('#cartitemtotal_' + params.pid)
  const cart_total_quantity = document.querySelector('#cartTotalQuantity')
  const cart_total_price = document.querySelector('#cartTotalPrice')
  const cart_index = document.querySelector('.cart-table')
  const cart_gratis_shipment = document.querySelector('#cartGratisShipment');
  const cart_gratis_shipment_message = document.querySelector('#cartGratisShipmentMessage');

  let newQty = 0
  if (cart_item_qty) {
    newQty = (parseInt(cart_item_qty.value) - 1);
  }
  if (newQty > 0) {
    fetch('/cart-quantity-minus', {
      method: 'POST',
      credentials: 'include',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ "productId": params.pid })
    })
    .then(result => {
      const p = Promise.resolve(result.json());
      p.then(v => {
        if (!cart_index) {
          cart_total_quantity.innerHTML = v.total_quantity
          cart_total_price.innerHTML = v.total + ' '+ v.price_message;
          cart_item_total.innerHTML = v.total_item + ' '+ v.price_message;
          cart_item_qty.value = (parseInt(cart_item_qty.value) - 1);
          cart_badge.innerHTML = parseInt(v.total_quantity);
          cart_gratis_shipment.innerHTML = v.shipment_gratis;
          cart_gratis_shipment_message.innerHTML = v.shipment_gratis_message;
        } else {
          document.querySelectorAll('.cart-index-total-quantity').forEach(i => {
            i.innerHTML = v.total_quantity
          })
          document.querySelectorAll('.cart-index-total-price').forEach(i => {
            i.innerHTML = v.total + ' '+ v.price_message
          })
          cart_item_total.innerHTML = v.total_item + ' '+ v.price_message;
          cart_item_qty.value = (parseInt(cart_item_qty.value) - 1);
        }
      })
    })
  } else {
    if (cart_dropdown) {
      cartDeleteItem({ pid: params.pid });
      cart_badge.innerHTML = v.quantity;
    } else {
      confirmDeleteCartItem({ pid: params.pid });
    }
  }
}

export const plusCartItem = (params) => {
  const cart_item_qty = document.querySelector('#cartitemqty_' + params.pid)
  const cart_item_total = document.querySelector('#cartitemtotal_' + params.pid)
  const cart_total_quantity = document.querySelector('#cartTotalQuantity')
  const cart_total_price = document.querySelector('#cartTotalPrice')
  const cart_index = document.querySelector('.cart-table')
  const cart_gratis_shipment = document.querySelector('#cartGratisShipment');
  const cart_gratis_shipment_message = document.querySelector('#cartGratisShipmentMessage');

  fetch('/cart-quantity-plus', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ "productId": params.pid })
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        if (!cart_index) {
          cart_total_quantity.innerHTML = v.total_quantity;
          cart_total_price.innerHTML = v.total + ' '+ v.price_message;
          cart_item_total.innerHTML = v.total_item + ' '+ v.price_message;
          cart_item_qty.value = (parseInt(cart_item_qty.value) + 1);
          cart_badge.innerHTML = parseInt(v.total_quantity);
          cart_gratis_shipment.innerHTML = v.shipment_gratis;
          cart_gratis_shipment_message.innerHTML = v.shipment_gratis_message;
        } else {
          document.querySelectorAll('.cart-index-total-quantity').forEach(i => {
            i.innerHTML = v.total_quantity
          })
          document.querySelectorAll('.cart-index-total-price').forEach(i => {
            i.innerHTML = v.total + ' '+ v.price_message
          })
          document.querySelectorAll('.cart-index-total-shipment').forEach(i => {
            i.innerHTML = v.shipment_gratis
          })
          document.querySelectorAll('.cart-index-total-shipment-message').forEach(i => {
            i.innerHTML = v.shipment_gratis_message
          })
          cart_item_total.innerHTML = v.total_item + ' '+ v.price_message;
          cart_item_qty.value = (parseInt(cart_item_qty.value) + 1);
        }
      } else {
        snackbar.open()
        snackbar.labelText = v.message
      }
    })
  })
  .catch(err => {console.log(err)
  });
}

export const cartDeleteItem = (params) => {
  const cart_total_quantity = document.querySelector('#cartTotalQuantity')
  const cart_total_price = document.querySelector('#cartTotalPrice')
  const cart_gratis_shipment = document.querySelector('#cartGratisShipment');
  const cart_gratis_shipment_message = document.querySelector('#cartGratisShipmentMessage');

  fetch('/cart-delete-item', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ "productId": params.pid, "silent": 1})
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      cart_total_quantity.innerHTML = v.quantity;
      cart_total_price.innerHTML = v.total + ' '+ v.price_message;;
      cart_badge.innerHTML = parseInt(v.quantity);
      cart_gratis_shipment.innerHTML = v.shipment_gratis;
      cart_gratis_shipment_message.innerHTML = v.shipment_gratis_message;

      document.querySelector('#cartitem_' + params.pid).remove()
    })
  })
}
